import { Collection, HandlersCollection } from '@tblabs/truffle';
import { SelectableItem } from './SelectableItem';


export class SelectableCollection<T> extends Collection<SelectableItem<T>>
{
    private lastSelectedItem: SelectableItem<T> | null = null;
    public OnSelect = new HandlersCollection<(item: T) => void>();

    constructor(items?: T[])
    {
        super(items?.map(item => new SelectableItem(item, this)));
    }

    public get LastSelected(): SelectableItem<T> | null
    {
        return this.lastSelectedItem;
    }

    public AddOne(item: T): this
    {
        return super.Add(new SelectableItem(item, this));
    }

    public Get(index: number): T
    {
        return this.Items[index].Item;
    }

    public Select(item: number | SelectableItem<T>): T
    {
        if (typeof item === 'number')
        {
            item = this.Items[item];
        }

        if (this.lastSelectedItem)
            this.lastSelectedItem.IsSelected.value = false;

        item.IsSelected.value = true;
        this.lastSelectedItem = item;
        this.OnSelect.Call(item.Item);
        
        return item.Item;
    }

    public get IsSelected(): boolean
    {
        // return this.lastSelectedItem !== null;
        return this.lastSelectedItem?.IsSelected?.value ?? false;
    }

    public Deselect(): void
    {
        if (this.lastSelectedItem)
            this.lastSelectedItem.IsSelected.value = false;

        // this.lastSelectedItem = null;
    }
}
